<template>
  <main class="main main--home">
    <div class="gradient-bg"/>

    <component
      v-for="(component, index) in components"
      :key="index"

      :is="component"
    />

    <ui-footer/>
  </main>
</template>

<script>
// Models
import meta from 'models/meta';

// Services
import { createMeta } from 'services/meta';

// Ui
import UiFooter from 'ui/Footer';

// Pages
import PagesHomeFaqs from 'pages/home/Faqs';
import PagesHomeInstructions from 'pages/home/Instructions';
import PagesHomeDentists from 'pages/home/Dentists';
import PagesHomeHero from 'pages/home/Hero';
// import PagesHomeWho from 'pages/home/Who';
// import PagesHomeWhy from 'pages/home/Why';
import PagesHomeOurMission from 'pages/home/OurMission';
// import PagesHomeComingSoon from 'pages/home/ComingSoon';

// Export
export default {
  name: `view-home`,

  // Meta data
  metaInfo: {
    title: meta.home.title,
    meta: createMeta(meta.home.meta),
  },

  // Components
  components: {
    UiFooter,
  },

  // Data
  data() {
    return {
      components: {
        PagesHomeHero,
        PagesHomeInstructions,
        // PagesHomeWho,
        // PagesHomeWhy,
        PagesHomeOurMission,
        // PagesHomeComingSoon,
        PagesHomeFaqs,
        PagesHomeDentists,
      },
    };
  },
};
</script>



// WEBPACK FOOTER //
// Home.vue?2892e8d0